var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 9.58416L10.3629 15.5293C9.59064 16.2577 8.54325 16.6668 7.45112 16.6668C6.35899 16.6668 5.3116 16.2577 4.53935 15.5293C3.7671 14.801 3.33325 13.8132 3.33325 12.7832C3.33325 11.7532 3.7671 10.7653 4.53935 10.037L10.843 4.09183C11.3579 3.60628 12.0561 3.3335 12.7842 3.3335C13.5123 3.3335 14.2106 3.60628 14.7254 4.09183C15.2402 4.57738 15.5295 5.23593 15.5295 5.9226C15.5295 6.60928 15.2402 7.26783 14.7254 7.75338L8.41485 13.6986C8.15743 13.9413 7.8083 14.0777 7.44426 14.0777C7.08022 14.0777 6.73109 13.9413 6.47367 13.6986C6.21625 13.4558 6.07164 13.1265 6.07164 12.7832C6.07164 12.4398 6.21625 12.1106 6.47367 11.8678L12.2972 6.38192",
    stroke: "#4E525E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.14d46ba4e258c8291a843f3b20b2a96c.svg";
export { ForwardRef as ReactComponent };